import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import HotSeat from './HotSeat';
import RedFlagGreenFlag from './RedFlagGreenFlag';
import TruthOrDare from './TruthOrDare';
import { Flame, Flag, Dice6, ArrowLeft } from 'lucide-react';

const games = [
  { id: 'hot-seat', icon: <Flame className="w-6 h-6" />, emoji: '\u{1F3AF}', titleKey: 'hotSeat', descKey: 'hotSeatDesc' },
  { id: 'red-flag', icon: <Flag className="w-6 h-6" />, emoji: '\u{1F6A9}', titleKey: 'redFlagGreenFlag', descKey: 'rfgfDesc' },
  { id: 'truth-dare', icon: <Dice6 className="w-6 h-6" />, emoji: '\u{1F3B2}', titleKey: 'truthOrDare', descKey: 'todDesc' },
];

export default function GameLobby({ roomId, isHost }) {
  const { t } = useLanguage();
  const [selectedGame, setSelectedGame] = useState(null);

  if (selectedGame === 'hot-seat') return <HotSeat onBack={() => setSelectedGame(null)} />;
  if (selectedGame === 'red-flag') return <RedFlagGreenFlag onBack={() => setSelectedGame(null)} />;
  if (selectedGame === 'truth-dare') return <TruthOrDare onBack={() => setSelectedGame(null)} />;

  return (
    <div data-testid="game-lobby" className="p-4 space-y-4">
      <h3 className="font-display text-xl font-bold mb-2">{t('games')}</h3>
      <p className="text-slate-400 text-sm mb-4">Choose a game to play with everyone in the room!</p>
      {games.map(game => (
        <button key={game.id} data-testid={`game-${game.id}`}
          onClick={() => setSelectedGame(game.id)}
          className="w-full game-card flex items-center gap-4 text-left hover:border-[#FF007F]/30">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FF007F]/20 to-[#E0115F]/20 flex items-center justify-center text-[#FF007F] shrink-0">
            {game.icon}
          </div>
          <div>
            <h4 className="font-semibold">{t(game.titleKey)}</h4>
            <p className="text-slate-400 text-sm">{t(game.descKey)}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
